<template>
  <Form ref="quotesGroupCreateQuoteForm" :model="formData">
    <FormItem :label="$t('quote.info.title')" prop="title" :rules="{ required: true, message: $t('quote.title_is_required') }">
      <Input v-model="formData.title"></Input>
    </FormItem>
    <FormItem :label="$t('quote.info.product')" prop="product_id" :rules="{ required: true, message: $t('quote.product_is_required') }">
      <Input :value="productName" disabled></Input>
    </FormItem>
    <FormItem :label="$t('quote.info.nsf_phase')" prop="nsf_phase" :rules="{ required: true, message: this.$t('quote.nsf_phase_is_required') }">
      <NsfPhaseSelect v-model="formData.nsf_phase"></NsfPhaseSelect>
    </FormItem>
    <FormItem :label="$t('quote.info.quantity')" prop="quantity" :rules="{ required: true, message: $t('quote.quantity_is_required') }">
      <InputNumber v-model="formData.quantity" :min="1"></InputNumber>
    </FormItem>
    <FormItem :label="$t('quote.info.currency')" prop="currency" :rules="{ required: true, message: $t('quote.currency_is_required') }">
      <CurrencySelect :value.sync="formData.currency" disabled></CurrencySelect>
    </FormItem>
    <FormItem class="hasDesc" :label="$t('exchange_rate')" prop="exchange_rate" :rules="{ required: true, message: $t('quote.exchange_rate_is_required') }">
      <InputNumber v-model="formData.exchange_rate"></InputNumber>
    </FormItem>
    <FormItem :label="$t('quote.info.expected_delivery_date')" prop="expected_delivery_date">
      <DatePicker v-model="formData.expected_delivery_date" type="date" format="yyyy-MM-dd"></DatePicker>
    </FormItem>
    <FormItem :label="$t('quote.info.expires_date')" prop="expires_date" :rules="{ required: true, message: $t('quote.expires_date_is_required') }">
      <DatePicker v-model="formData.expires_date" type="date" format="yyyy-MM-dd"></DatePicker>
    </FormItem>
    <FormItem :label="$t('quote.info.method')" prop="method" :rules="{ required: true, message: $t('quote.method_is_required') }">
      <QuoteMethodSelect v-model="formData.method" :placeholder="$t('quote.select_quote_method')" disabled></QuoteMethodSelect>
    </FormItem>
    <FormItem class="text-align-right">
      <Button @click="handleSubmit" type="primary">{{ $t('save') }}</Button>
    </FormItem>
  </Form>
</template>

<script>
import CurrencySelect from '@/components/currency'
import { QuoteMethodSelect } from '../form-controls'
import NsfPhaseSelect from '@/components/nexpcb/form-controls/nsf-phase-select'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: "QuotesGroupCreateQuoteForm",
  components: {
    CurrencySelect,
    QuoteMethodSelect,
    NsfPhaseSelect
  },
  props: {
    quoteGroupInstance: {
      type: Object,
      required: true
    }
  },
  computed: {
    productName () {
      return this.quoteGroupInstance.product?.product_name
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  mounted () {
    this.formData = _.cloneDeep(this.quoteGroupInstance)
    this.formData.expires_date = moment(this.quoteGroupInstance.expires_at).format('YYYY-MM-DD')
    this.formData.method = this.quoteGroupInstance.type
  },
  methods: {
    ...mapActions(['createQuoteFromQuoteGroup']),
    moment,
    handleSubmit () {
      this.$refs['quotesGroupCreateQuoteForm'].validate((valid) => {
        if (valid) {
          this.formData['expires_at'] = moment(this.formData['expires_at']).format('YYYY-MM-DD')
          this.createQuoteFromQuoteGroup({ id: this.quoteGroupInstance.id, data: this.formData })
            .then((resp) => {
              this.$emit('on-saved', resp.data)
              this.$Message.success($t('quote.quote_created_success_message'))
            })
        }
      })
    }
  }
}
</script>
